/**
 * 联系人信息
 * @author Created by jiamei.yao 2017/05/22
 */

'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, Image} from 'react-native';
import BaseInfo from '../../baseInfo/index';
import styles from './style';
import QImageSet from '../../../../../assets/QImageSet';

class priceCard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let flight = this.props.data || {};

        let {
            labelItem,  price,
            averagePrice, reductionLabelItem
        } = flight || {};

        reductionLabelItem = reductionLabelItem || {}

        const reduction = reductionLabelItem.text || 0;
        let priceImage = QImageSet.section1;
        let priceColor;
        let shadowColor = '#ffffff';
        if (0 < reduction && reduction < 70) {
            priceImage = QImageSet.section1;
            priceColor = '#FF9F00';
            shadowColor = 'rgba(255,191,89,0.20)'
        } else if (70 <= reduction && reduction < 80) {
            priceImage = QImageSet.section2;
            priceColor = '#FF8316';
            shadowColor = 'rgba(255,131,22,0.20)'
        } else if (80 <= reduction && reduction < 90) {
            priceImage = QImageSet.section3;
            priceColor = '#FF5900';
            shadowColor = 'rgba(255,102,0,0.20)'
        } else if (90 <= reduction && reduction <= 100) {
            priceImage = QImageSet.section4;
            priceColor = '#EE1D2F';
            shadowColor = 'rgba(238,29,47,0.20)'
        }

        return (
            <TouchableOpacity style={[styles.cheapPriceCard]} onPress={()=>{this.props.jump(flight)}}>
                {
                    labelItem && (
                        <View
                            style={[styles.label, {backgroundColor: labelItem.bgColor}]}>
                            <Image source={{uri: labelItem.image}}
                                   style={styles.labelImg}/>
                            {labelItem.icon &&
                            <Text style={styles.labelIcon}>{labelItem.icon}</Text>}
                            <Text
                                style={[styles.labelText, {color: labelItem.textColor}]}>{labelItem.text}</Text>
                        </View>
                    )
                }

                <BaseInfo
                    data={flight}
                    config={{subTitleTop: 0, baseInfoStyle: styles.priceBaseInfo}}/>

                <View style={styles.priceTrendField}>
                    <Image style={styles.priceTrendPic} source={{uri: priceImage}}/>

                    <View style={[styles.priceTrendPercent, {backgroundColor: priceColor, shadowColor: shadowColor}]}>
                        <Text style={styles.priceTrendPercentTip}>降</Text>
                        <Text style={styles.priceTrendPercentText}>{reduction}%</Text>
                    </View>
                    <View style={styles.lowPrice}>
                        <Text style={styles.lowPriceTip}>最低价&yen;</Text>
                        <Text style={styles.lowPriceText}>{price}</Text>
                    </View>
                </View>

                <View style={styles.averagePrice}>
                    <Text style={styles.averagePriceTip} numberOfLines={1} >近三十天均价</Text>
                    <Text style={styles.averatePriceText}>&yen;{averagePrice}</Text>
                    <Text style={[styles.averagePriceTip, styles.averagePriceAfterTip]} numberOfLines={1}>，即将恢复</Text>
                </View>
            </TouchableOpacity>
        )
    }
}

export default priceCard;
